/**
 * Converts the object keys from snake_case to camelCase
 * @param obj - The object to convert
 * @returns The converted object
 */
export const snakeToCamel = <T>(obj: T): T => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => snakeToCamel(item)) as unknown as T;
  }

  const transformed: T = {} as T;
  for (const [key, value] of Object.entries(obj)) {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    transformed[camelKey] = snakeToCamel(value) as T[keyof T];
  }
  return transformed;
};
